import { FunctionalComponent } from 'preact';
import { Suspense, lazy } from 'preact/compat';
import { useState } from 'preact/hooks';

import styles from './style.module.scss';

const Popover = lazy(() => import('./Popover'));

// -----------------------------------------------------------------------------

const Apps: FunctionalComponent = () => {
  const [isOpened, setOpened] = useState(false);
  const togglePopup = () => setOpened((v) => !v);

  const handleClose = () => {
    setOpened(false);
  };

  return (
    <div className={isOpened ? styles.active : ''}>
      <button className={styles.triggerButton} onClick={togglePopup}>
        <img src="img/dialpad.webp" width="45" height="45" alt="Apps" />
      </button>

      {isOpened && (
        <Suspense fallback={null}>
          <Popover onClose={handleClose} />
        </Suspense>
      )}
    </div>
  );
};

export default Apps;
